import { css } from '@emotion/react';
import { VirtuosoGrid } from 'react-virtuoso';
import { FaxMediaQueries } from '@frontend/api-fax-media';
import { Page } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { breakpoints } from '@frontend/responsiveness';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { useSearch } from '@frontend/weave-router';
import { theme } from '@frontend/theme';
import { SpinningLoader } from '@frontend/design-system';
import { TemplateCard } from '../components/templates/template-card';

export const CONTAINER_HEIGHT = `calc(100vh - ${theme.spacing(30)})`;

export const SendFaxWizardChooseTemplatePage = () => {
  const { t } = useTranslation('fax');
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const faxTemplatesFlag = getFeatureFlagValue('fax-templates');
  const { selectedLocationId } = useSearch({ from: '/fax/drafts/$draftId/choose-template', shouldThrow: false }) ?? {};
  const { selectedLocationIds } = useAppScopeStore();
  const locationId = selectedLocationId || selectedLocationIds[0];

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    FaxMediaQueries.useInfiniteListCoversheetTemplate(locationId, [locationId], '', {
      enabled: faxTemplatesFlag,
    });

  const templates = data ? data.pages.flatMap((page) => page.coversheetTemplates) : [];

  const getNextPage = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  return (
    <Page
      breadcrumbs={[
        { label: t('Fax Inbox'), to: '/fax/inbox' },
        { label: t('Select a Cover Sheet Type'), to: '/fax/drafts/new' },
        { label: t('Select Template') },
      ]}
    >
      <h4
        css={{
          color: theme.colors.neutral50,
        }}
      >
        {t('All Templates')}
      </h4>

      <div css={{ height: CONTAINER_HEIGHT, width: '100%', marginTop: theme.spacing(2) }}>
        {isLoading && (
          <div css={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: theme.spacing(2) }}>
            <SpinningLoader />
          </div>
        )}
        {templates?.length ? (
          <VirtuosoGrid
            css={css`
              width: 100%;
              .virtuoso-grid-list {
                display: flex;
                flex-wrap: wrap;
                gap: ${theme.spacing(2)};
                .virtuoso-grid-item {
                  width: calc(33.33% - ${theme.spacing(1.35)});
                  @media (max-width: ${breakpoints.medium.max}px) {
                    width: calc(50% - ${theme.spacing(1.35)});
                  }
                  @media (max-width: ${breakpoints.small.min}px) {
                    width: 100%;
                  }
                }
              }
            `}
            data={templates}
            totalCount={templates?.length}
            itemContent={(_index, template) => (
              <TemplateCard key={template.id} template={template} locationId={locationId} />
            )}
            endReached={getNextPage}
          />
        ) : null}
      </div>
    </Page>
  );
};
